// "Product tour seen" flag, device-scoped in localStorage. Replaces the old
// `ces.onboarding.done` flag (which a legacy install may still carry — it
// counts as seen so a returning user isn't shown the tour again).

export const TOUR_SEEN_KEY = "ces.tour.v1";
const LEGACY_KEY = "ces.onboarding.done";

export type StorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function defaultStorage(): StorageLike | null {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** Has this device already seen (or skipped) the tour? Unavailable storage
 *  reads as "not seen" — worst case the welcome card shows once more. */
export function isTourSeen(storage: StorageLike | null = defaultStorage()): boolean {
  try {
    return storage?.getItem(TOUR_SEEN_KEY) === "1" || storage?.getItem(LEGACY_KEY) === "1";
  } catch {
    return false;
  }
}

/** Remember the tour is done/skipped so it never auto-opens again. */
export function markTourSeen(storage: StorageLike | null = defaultStorage()): void {
  try {
    storage?.setItem(TOUR_SEEN_KEY, "1");
  } catch {
    /* quota / disabled storage — the card simply shows again next time */
  }
}

/** Forget the flag so the welcome card shows again (the Settings replay). */
export function resetTourSeen(storage: StorageLike | null = defaultStorage()): void {
  try {
    storage?.removeItem(TOUR_SEEN_KEY);
    storage?.removeItem(LEGACY_KEY);
  } catch {
    /* ignore */
  }
}
